import { Dispatch, SetStateAction } from 'react';
import { useGroupProductsMergeAction } from '@/components/action-buttons/use-group-products-merge-action';
import { useGroupBrandsMergeAction } from '@/components/action-buttons/use-group-brands-merge-action';
import type { GroupMergePayload } from '@/components/action-buttons/use-group-merge-modal-orchestration';

type UseGroupMergeActionsParams = {
    accessToken: string;
    selectionSessionId: string;
    setPickedProducts?: (val: string[]) => void;
    setPickedBrandGroups?: (val: string[]) => void;
    refetchReviewsAndProducts: () => Promise<void>;
    setIsGroupsMergeLoading: Dispatch<SetStateAction<boolean>>;
};

type UseGroupMergeActionsReturn = {
    groupPickedProducts: (payload: GroupMergePayload) => Promise<boolean>;
    groupPickedBrands: (payload: GroupMergePayload) => Promise<boolean>;
};

export const useGroupMergeActions = ({
    accessToken,
    selectionSessionId,
    setPickedProducts,
    setPickedBrandGroups,
    refetchReviewsAndProducts,
    setIsGroupsMergeLoading,
}: UseGroupMergeActionsParams): UseGroupMergeActionsReturn => {
    const { groupPickedProducts } = useGroupProductsMergeAction({
        accessToken,
        selectionSessionId,
        setPickedProducts,
        refetchReviewsAndProducts,
        setIsGroupsMergeLoading,
    });
    const { groupPickedBrands } = useGroupBrandsMergeAction({
        accessToken,
        setPickedBrandGroups,
        refetchReviewsAndProducts,
        setIsGroupsMergeLoading,
    });

    return {
        groupPickedProducts,
        groupPickedBrands,
    };
};
